<template>
  <div class="madepaper">
    <div class="searchBox">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input
            size="small"
            v-model="search"
            placeholder="搜索试题名称"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            size="small"
            v-model="keyword"
            placeholder="搜索关键词"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-select
            size="small"
            v-model="difficult"
            clearable
            placeholder="选择难易度"
          >
            <el-option
              v-for="item in difficulty"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            size="small"
            v-model="choseType"
            clearable
            placeholder="选择试题类型"
          >
            <el-option
              v-for="item in type"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-cascader
            size="small"
            :options="chapter"
            :props="{ checkStrictly: true }"
            placeholder="选择科目/章节"
            v-model="chapter_id"
            clearable
            @change="handleChange"
          ></el-cascader>
        </el-col>
        <el-col :span="4">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="handleSeach"
            >搜索</el-button
          >
        </el-col>
      </el-row>
    </div>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="题干" width="180">
        <template slot-scope="scope">
          <span v-html="scope.row.name"></span>
        </template>
      </el-table-column>
      <el-table-column label="关键词" width="180">
        <template slot-scope="scope">
          <span v-html="scope.row.keyword"></span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="题型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">单选题</span>
          <span v-if="scope.row.type == 2">多选题</span>
          <span v-if="scope.row.type == 3">判断题</span>
          <span v-if="scope.row.type == 4">填空题</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="parsing" label="解析" width="180"></el-table-column> -->

      <!-- <el-table-column prop="chapter_id" label="所属章节" width="180"></el-table-column> -->
      <el-table-column
        prop="difficulty"
        label="难易度"
        width="180"
      ></el-table-column>
    </el-table>
    <div class="pages" v-if="total">
      <div class="pages-item">
        <p class="pages-text">
          每页显示{{ pageSize }} 条记录，共 {{ total }}条记录
        </p>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next"
        :total="total"
        class="pages-item"
      ></el-pagination>
    </div>
    <el-button @click="submit" type="primary">确定</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      keyword: "",
      difficult: "",
      chapter_id: [],
      tableData: [],
      multipleSelection: [],
      pageSize: 20,
      total: 0,
      current: 0,
      page: 1,
      difficulty: ["A", "B", "C", "D", "E"],
      chapter: [],
      type: [
        {
          id: "1",
          label: "单选题",
        },
        {
          id: "2",
          label: "多选题",
        },
        {
          id: "3",
          label: "判断题",
        },
        {
          id: "4",
          label: "填空题",
        },
      ],
      choseType: null,
    };
  },
  created() {
    this.init();
    this.getChapter();
  },
  methods: {
    init() {
      let _this = this;
      _this.$http
        .post(process.env.VUE_APP_URL + "banks", {
          search: this.search,
          chapter_id: this.chapter_id[1] ? this.chapter_id[1] : "",
          course_id: this.chapter_id[0],
          difficulty: this.difficult,
          keyword: this.keyword,
          type: this.choseType,
          page: this.page,
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.tableData = data.data.data;
            _this.total = data.data.count;
            _this.current = Math.ceil(_this.total / 1);
          } else {
            _this.$message.error(data.data.msg);
          }
        });
    },
    getChapter() {
      let _this = this;
      _this.$http
        .get(process.env.VUE_APP_URL + "chapter")
        .then(function(data) {
          if (data.data.code == 200) {
            let chapter = data.data.data;
            let arr = [];
            if (chapter) {
              chapter.forEach((item) => {
                let obj = {
                  label: item.name,
                  value: item.id,
                  children: [],
                };
                if (item.children) {
                  item.children.forEach((ch) => {
                    obj.children.push({
                      value: ch.id,
                      label: ch.name,
                    });
                  });
                }
                arr.push(obj);
              });
              _this.chapter = arr;
            }
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = [];
      val.forEach((item) => {
        this.multipleSelection.push(item.id);
      });
    },
    handleSeach() {
      this.page = 1;
      this.init();
    },
    handleCurrentChange(currentPage) {
      this.page = currentPage;
      this.multipleSelection = [];
      this.init();
    },
    submit() {
      if (this.multipleSelection.length > 0) {
        this.multipleSelection = JSON.stringify(this.multipleSelection);
      } else {
        this.$message.warning("请选择试题");
        return;
      }

      let _this = this,
        params = {
          id: this.$route.params.id,
          question: this.multipleSelection,
        };
      _this.$http
        .post(process.env.VUE_APP_URL + "bankInsert", params)
        .then(function(data) {
          if (data.data.code == 200) {
            _this.multipleSelection = [];
            _this.$refs.multipleTable.clearSelection();
            _this.$emit("handleMadePaper");
          } else {
            _this.multipleSelection = [];
            _this.$refs.multipleTable.clearSelection();
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.multipleSelection = [];
          _this.$refs.multipleTable.clearSelection();
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    handleChange(val) {
      console.log(val);
    },
  },
};
</script>
<style lang="less" scoped>
.searchBox {
  margin: 10px auto;
  padding: 0 5px;
}
.madepaper {
  text-align: center;
}
.pages {
  padding: 10px;
  text-align: right;
  font-size: 14px;
  color: #606266;
  .pages-item {
    display: inline-block;
    vertical-align: middle;
  }
  .el-pagination {
    margin-left: 20px;
  }
}
img {
  width: 100px;
}
</style>
